import React from 'react';
import { useRoleContext } from '../auth/RoleContext';
import { canSeeSidebarItem, getUserType, PLATFORMS } from '../auth/permissionsConfig';
import { useTenant } from '../config/tenantConfig';
import RestrictedAccess from './RestrictedAccess';

/**
 * ProtectedRoute - Wraps a component and checks if user has permission to view it
 * @param {React.Component} children - The component to render if authorized
 * @param {string} permissionKey - The SIDEBAR_ITEM_KEY to check (e.g., 'marketplace', 'invoiceDetail')
 * @param {string} customMessage - Optional custom message for restricted access page
 */
const ProtectedRoute = ({ children, permissionKey, customMessage }) => {
    const { user } = useRoleContext();
    const { tenantType } = useTenant();

    // Determine platform from tenant type
    const getPlatform = () => {
        if (tenantType === 'halitrade') return PLATFORMS.HALITRADE;
        return PLATFORMS.HALIFLOW;
    };

    const platform = getPlatform();

    // Check if user has permission
    const hasPermission = canSeeSidebarItem(user, platform, permissionKey);

    // If user has permission, render the children
    if (hasPermission) {
        return children;
    }

    // Otherwise, show restricted access page
    return (
        <RestrictedAccess
            title="Restricted Access"
            message={customMessage || `You do not have permission to access this page. Please contact your administrator for access.`}
        />
    );
};

export default ProtectedRoute;
